import * as z from 'zod';

export const storeDetailsSchema = z.object({
    TimeZone: z.optional(z.string()),
    ParentStore: z.optional(z.string()),
});

export type StoreDetails = z.infer<typeof storeDetailsSchema>;

export const isStoreDetails = (value: unknown): value is StoreDetails => {
    return storeDetailsSchema.safeParse(value).success;
};

export const modifyReasonCodes = z.enum([
    'CUSCHMIND',
    'DELAY',
    'SALESSTOP',
    'SALESERR',
    'SP_NO_CAPACITY',
    'WRONG_ZIP_CODE',
    'IKEA_DECISION',
]);

export type ModifyReasonCodesData = z.infer<typeof modifyReasonCodes>;

export const isModifyReasonCodes = (value: unknown): value is ModifyReasonCodesData => {
    return modifyReasonCodes.safeParse(value).success;
};
